import React, { useEffect, useState } from 'react';
import styles from '../static/styles/Rewards.module.css';
import { redeemReward } from '../api/rewards';
import weeklyTournamentBg from '../static/img/WeeklyTournaments/imagePubgWeeklyTournament.avif';
import freeFireIcon from '../static/img/DailyGamingTasks/iconFreeFireDailyTasks.avif';
import { getRewardsList } from '../api/rewards';

import MessagePopup from '../components/MessagePopup';

import playstation5Img from '../static/img/Rewards/Playstation5.avif';
import asusRogStrixGoImg from '../static/img/Rewards/AsusROGStrixGoUSBCGamingHeadset.avif';
import asusRogDeltaSCoreImg from '../static/img/Rewards/AsusROGDeltaSCoreGamingHeadphone.avif';
import edifierG1Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG2.avif';
import edifierG2Img from '../static/img/Rewards/EdifierUSBGamingHeadsetG2.avif';
import asusTufKeyboardImg from '../static/img/Rewards/asus_keyboard.avif';
import bloodyB760Img from '../static/img/Rewards/bloody_keyboard.avif';
import bloodyB865NImg from '../static/img/Rewards/BloodyMechanicalGamingKeyboardB865N.avif';
import asusGladiusImg from '../static/img/Rewards/AsusROGGladiusIIIP514GamingMouse.avif';
import asusKerisImg from '../static/img/Rewards/AsusROGKerisP509GamingMouse.avif';
import pubgImg from '../static/img/Rewards/pubgReward.jpg';
import fortniteImg from '../static/img/Rewards/fortniteReward.avif';
import minecraftImg from '../static/img/Rewards/mirecraft_Reward.jpg';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated } from '../api/auth';
import { jwtDecode } from 'jwt-decode';
import GameNowPopup from '../components/GameNowPopup';


const Rewards = () => {
    const [message, setMessage] = useState(null);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [showGameNow, setShowGameNow] = useState(false);
    const [rewardsData, setRewardsData] = useState([]);
    const [loadingRewards, setLoadingRewards] = useState(true);
    const [errorRewards, setErrorRewards] = useState(null);
    const navigate = useNavigate();

    const getRewardImage = (rewardId) => {
        const id = parseInt(rewardId);
        switch(id) {
            case 11: return playstation5Img; // Playstation 5
            case 12: return asusRogDeltaSCoreImg; // Asus ROG Gaming Headphone
            case 13: return edifierG1Img; // Edifier USB Gaming Headset
            case 14: return asusTufKeyboardImg; // Asus Gaming Keyboard
            case 15: return bloodyB760Img; // Bloody Mechanical Gaming Keyboard
            case 16: return asusGladiusImg; // Asus ROG Gaming Mouse
            case 1: case 2: case 3: case 4: return pubgImg; // PUBG Mobile UC
            case 6: case 7: case 8: return fortniteImg; // Fortnite V-Bucks
            case 9: case 10: return minecraftImg; // Minecraft Minecoins
            default: return pubgImg;
        }
    };

    useEffect(() => {
        document.title = "Rewards | Ufone ESG"
    }, [])

    useEffect(() => {
        const loadRewards = async () => {
            try {
                setLoadingRewards(true);
                setErrorRewards(null);
                const response = await getRewardsList();
                if (response && response.data && Array.isArray(response.data)) {
                    setRewardsData(response.data);
                } else {
                    setRewardsData([]);
                }
            } catch (err) {
                setErrorRewards(err.message || 'Failed to load rewards');
            } finally {
                setLoadingRewards(false);
            }
        };
        loadRewards();
    }, []);

    const handleRedeem = async (rewardId) => {
        try {
            if(!isAuthenticated()) {
                window.location.href = process.env.REACT_APP_LOGIN_URL;
                return;
            }

            const accessToken = localStorage.getItem("access_token");
            const decoded = jwtDecode(accessToken);

            if(decoded.gn) {
                if(decoded.gn === 1) {
                    setShowGameNow(true)
                    return;
                }
            }
            const response = await redeemReward(parseInt(rewardId));

            if (response.status === 200) {
                if (response.data.success) {
                    navigate('/redeem', { state: { reward: response.data.data } });
                } else if (response.data?.data.details) {
                    setMessage(response.data?.data.details);  // ???
                    setIsPopupOpen(true);
                } else if (response.data?.data.message) {
                    setMessage(response.data?.data.message);
                    setIsPopupOpen(true);
                } else {
                    setMessage('An error occurred. Please try again.');
                    setIsPopupOpen(true);
                }
            }
        } catch (error) {
            setMessage(error.data?.message || 'An error occurred. Please try again.');
            setIsPopupOpen(true);
            // console.log(error);
        } finally {
        }
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setMessage(null);
    };


    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>Rewards</h2>
            <p className={styles.subheading}>Win Gaming Accessories & Currencies</p>
            
            {loadingRewards && <div className={styles.loading}>Loading rewards...</div>}
            {errorRewards && <div className={styles.error}>Error: {errorRewards}</div>}
            
            {!loadingRewards && !errorRewards && (
                <div className={styles.cardGrid}>
                    {rewardsData.map((reward, index) => (
                        <div key={reward.id || reward.name} className={styles.cardWrapper}>
                            <div className={styles.card}>
                                <div
                                    className={styles.cardContent}
                                    style={{ backgroundImage: `url(${getRewardImage(reward.id)})` }}
                                >
                                    {!reward.name?.toLowerCase().includes('playstation') && (
                                        <span className={styles.rewardNameOverlay}>{reward.name}</span>
                                    )}
                                    <div className={styles.rewardCreditsOverlay}>
                                        <span className={styles.rewardCreditsLabel}>CREDITS<br />REQUIRED</span>
                                        <span className={styles.rewardCreditsValue}>{reward.credits ? reward.credits.toLocaleString() : 'N/A'}</span>
                                    </div>
                                </div>
                            </div>
                            <button
                                className={styles.redeemButton}
                                onClick={() => handleRedeem(reward.id)}
                                disabled={!reward.can_redeem}
                            >
                                {reward.can_redeem ? 'Redeem' : isAuthenticated() ? 'Insufficient Coins' : 'Login Required'}
                            </button>
                        </div>
                    ))}
                </div>
            )}
            {isPopupOpen && <MessagePopup
                isOpen={isPopupOpen}
                message={message}
                onClose={handleClosePopup}
            />}
            
            {showGameNow && <GameNowPopup isOpen={showGameNow} onClose={() => {setShowGameNow(false)}} />}
        </div>
    );
};

export default Rewards;